export default __webpack_public_path__ + "c381461cc4dce516b748250aa64fc1a2.png";